import { Box, Stack, Typography } from '@mui/material';
import type { ReportType } from '@parkchirp/reporting';
import type { ReactNode } from 'react';
import { ReportNavigation } from './ReportNavigation';

type Props = {
	children: ReactNode;
	selectedReportKey: ReportType | null;
	navigationDisabled: boolean;
	onSelectReport: (reportType: ReportType) => void;
};

export const ReportingLayout = ({ children, selectedReportKey, navigationDisabled, onSelectReport }: Props) => {
	return (
		<Box
			sx={{
				bgcolor: 'background.default',
				minHeight: 'calc(100vh - 48px)',
				p: 2,
				width: '100%',
			}}
		>
			<Stack
				spacing={2.5}
				sx={{
					width: '100%',
				}}
			>
				<Typography variant='h5' fontWeight={700}>
					Reports
				</Typography>

				<Box
					sx={{
						alignItems: 'flex-start',
						display: 'flex',
						gap: 3,
						minWidth: 960,
					}}
				>
					<ReportNavigation
						selectedReportKey={selectedReportKey}
						disabled={navigationDisabled}
						onSelectReport={onSelectReport}
					/>

					<Box
						component='main'
						sx={{
							flex: 1,
							minWidth: 0,
						}}
					>
						{children}
					</Box>
				</Box>
			</Stack>
		</Box>
	);
};
